<template>
<div>
    <div class="">
        <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
            <div class="card card-signin my-5">
                <div class="card-body shadow">

                    <div class="row mb10">
                        <div class="col-md-4"></div>
                        <div class="col-md-4" style="height: 100px;">
                            <img class="cinc-logo" />
                        </div>
                        <div class="col-md-4"></div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <h5 class="card-title text-center">Authorize Scopes</h5>

                            <div class="row pt10" v-if="promptForScopes">
                                <div class="col-md-2">
                                    <i class="fas fa-arrow-down ml10" style="color:red"></i>
                                </div>
                                <div class="col-md-9">
                                    <span style="color:red">Select which scopes you'd like to grant</span>
                                </div>
                            </div>

                            <div class="row pt10" v-for="scope in scopes" :key="scope.key">
                                <div class="col-md-2 scopes">
                                    <button v-bind:class="['select-scope-button-'+scope.Name, 'pointer', 'btn', 'btn-sm', 'btn-block', selectedScopes.includes(scope.Name) ? 'btn-dark' : 'btn-light']" style="border: 1px solid black" v-bind:data-scopename="scope.Name" v-on:click="selectScope(scope.Name)">
                                        <i class="fas fa-check" v-if="selectedScopes.includes(scope.Name)"></i>
                                        <i v-bind:class="scope.Icon" v-else></i>
                                    </button>
                                </div>
                                <div class="col-md-9">
                                    {{scope.Description}}
                                </div>
                                <div class="col-md-1">
                                    <i class="fa fa-info-circle" v-bind:title="scope.Details"></i>
                                </div>
                                <hr />
                            </div>
                            <button class="scopes-submit btn btn-lg btn-primary btn-block text-uppercase mt10" v-on:click="submitScopes">Submit</button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { ScopeDefinition, ScopeDefinitions } from '../../models/ScopeDefinition';

export default defineComponent({
    name: "Scope",
    setup() {
        let selectedScopes = ref(new Array<string>());
        let scopes = ref(new Array<ScopeDefinition>());
        let promptForScopes = ref(false);

        scopes.value.push(ScopeDefinitions.leads);
        scopes.value.push(ScopeDefinitions.broker);

        return {
            selectedScopes, scopes, promptForScopes
        }
    },
    //beforeMount() {
        // this.$store.state.axiosService.GetScopedDefinitions()
        //     .then((response : any) => {
        //         this.scopes = response;
        //     })
        //     .catch((response : any) => {
        //         console.log("Error getting scroped definitions.");
        //     });
    //},
    methods: {
        selectScope(newScopeName: string) {
            const scopeName = newScopeName;
            if (this.selectedScopes.indexOf(scopeName) > -1) {
                this.selectedScopes = this.selectedScopes.filter(x => x !== scopeName);
            }
            else {
                this.selectedScopes.push(scopeName);
            }
        },
        submitScopes() {
            if (this.selectedScopes.length === 0) {
                this.promptForScopes = true;
                return;
            }
            this.$router.push({ name:'Login', query:{ initiator: 'selfserve', scope: this.selectedScopes.join(' ')}})
        }
    }
})
</script>